export default "__VITE_ASSET__6aaad6b7__"